import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/triangle.png'


const _withScopeId = n => (_pushScopeId("data-v-6bfc3bdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sf-header bg-opPrimary px-[50px] h-[60px] flex" }
const _hoisted_2 = { class: "flex-1 flex items-center text-white text-[16px]" }
const _hoisted_3 = ["to", "onClick"]
const _hoisted_4 = { class: "flex items-center justify-around basis-[400px] flex-row-reverse" }
const _hoisted_5 = { class: "flex justify-center items-center text-center text-opWhite" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import queryString from 'query-string'
import { useRouter } from 'vue-router'
import { reactive, nextTick, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAppStore } from '@/stores/app'
interface TopMenuInterface {
    key:string;
    text:string;
    path:string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SfHeader',
  setup(__props) {

require('@/assets/svg/lgcn.svg')
const app = useAppStore()
console.log('app stores:', app)

const router = useRouter()
const { locale, t } = useI18n()
const isZh = ref(locale.value === 'zh-CN')
const changeLang = (lang:string) => {
//   app.changeLoading(true)
  locale.value = lang
  localStorage.setItem('open_lang', locale.value)
  setTimeout(() => {
    const params = queryString.parse(location.search)
    Reflect.deleteProperty(params, 'lang')
    const resultSearch = queryString.stringify(params)
    window.location.href = resultSearch
      ? `${window.location.origin}${window.location.pathname}?${resultSearch}`
      : `${window.location.origin}${window.location.pathname}`
  }, 200)
}

onMounted(() => {
  !app.customColor.opPrimary && app.genCustomColor()
})
const TopMenuArr = reactive<TopMenuInterface[]>([
  {
    key: 'document',
    text: 'header.document',
    path: '/document'
  },
  {
    key: 'question',
    text: 'header.question',
    path: '/question'
  },
  {
    key: 'sfInternetWeb',
    text: 'header.sfInternetWeb',
    path: 'https://www.sf-international.com/'
  }
])

const jumpToShop = () => {
  window.open(`${process.env.VUE_APP_SHOP_URL}?lang=${locale.value}`, '_blank')
}
const openConsole = () => {
  window.open(`${process.env.VUE_APP_CONSOLE_URL}?lang=${locale.value}`, '_blank')
}
const changeRoute = (item:TopMenuInterface):void => {
  if (item.path.indexOf('www') !== -1) {
    window.open(item.path, '_blank')
    return
  }
  app.setActiveMenu(item.key)
  router.push({
    path: item.path
  })
}
const goHome = () => {
  app.setActiveMenu('')
  router.push({
    path: '/'
  })
}


return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex items-center basis-[300px] cursor-pointer text-[16px]",
      onClick: goHome
    }, [
      _createVNode(_component_svg_icon, {
        name: "logo",
        width: 105,
        height: 32
      }),
      _createVNode(_component_svg_icon, {
        class: "mx-[20px]",
        name: isZh.value?'lgcn':'lgen',
        width: 70,
        height: 16
      }, null, 8, ["name"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TopMenuArr, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key+item.key,
          to: item.path,
          class: _normalizeClass(["px-[25px] flex justify-center items-center cursor-pointer h-[60px] hover:text-opSecondary", _unref(app).activeMenu===item.key?['text-opSecondary',' border-b-[3px]','border-opSecondary']:'']),
          onClick: _withModifiers(()=>changeRoute(item), ["prevent"])
        }, _toDisplayString(_unref(t)(item.text)), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[0] || (_cache[0] = ()=>changeLang('zh-CN'))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('zh-CN')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[1] || (_cache[1] = ()=>changeLang('en'))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('en')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_svg_icon, {
              name: "i18nLogo",
              width: 24,
              height: 24
            }),
            _createTextVNode(" " + _toDisplayString(_unref(locale)==='en'?_unref(t)('en'):_unref(t)('zh-CN')) + " ", 1),
            _hoisted_6
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "mx-[10px]",
          onClick: openConsole
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('header.console')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "mx-[10px] shop-btn",
          onClick: jumpToShop
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('header.shopHome')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})